import React, { useContext, useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

const TwitterContext = React.createContext();

const requestedScopes = ["profile", "email"];

function TwitterProvider({ children }) {
  const { getAccessTokenSilently, isAuthenticated, user } = useAuth0();
  const [accessToken, setAccessToken] = useState();
  const [ curUser, setCurUser ] = useState(null);
  const [ filter, setFilter ] = useState(null);

  useEffect(() => {
    const getAccessToken = async () => {
      try {
        // get access token silently from Auth0, which will be stored in the context
        const token = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE,
            scope: requestedScopes.join(" "),
          },
        });
        setAccessToken(token);
      } catch (err) {
        console.log(err);
      }
    };

    if (isAuthenticated) {
      getAccessToken();
    }
  }, [getAccessTokenSilently, isAuthenticated]);

  useEffect(() => {
    const getUser = async () => {
      try {
        if (!user || curUser) return;
        const curUserData = await fetch(`${process.env.REACT_APP_API_URL}/users/auth/${user.sub}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const curUserJson = await curUserData.json();
        setCurUser(curUserJson);
      } catch (err) {
        console.log(err);
      }
    };

    if (isAuthenticated) {
      getUser();
    }
  }, [curUser, user, accessToken, isAuthenticated]);

  useEffect(() => {
    console.log("filter", filter);
  }, [filter]);

  const updateTweetList = (filter) => {
    setFilter(filter);
  }
  const value = { accessToken, setAccessToken, curUser, filter, updateTweetList };
  return (
    <TwitterContext.Provider value={value}>
      {children}
    </TwitterContext.Provider>
  );
}

const useTwitterContext = () => useContext(TwitterContext);

export { useTwitterContext, TwitterProvider };
